import * as actionTypes from "./action-types";

const initialState = {
  burgerMenu: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_MENU:
      return {
        ...state,
        burgerMenu: !state.burgerMenu,
      };
    default:
      return state;
  }
};

export default reducer;
